import { render, staticRenderFns } from "./sub_order_list.vue?vue&type=template&id=1b3b7f4c&scoped=true"
import script from "./sub_order_list.vue?vue&type=script&lang=js"
export * from "./sub_order_list.vue?vue&type=script&lang=js"
import style0 from "./sub_order_list.vue?vue&type=style&index=0&id=1b3b7f4c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b7f4c",
  null
  
)

export default component.exports